import React, { useState, useEffect, useRef } from 'react';

import { useRecoilState } from 'recoil';
import { tokenAtom, attandanceAtom, userAtom } from '../../../core/config/atoms';

import Lottie from 'lottie-react';
import { toast } from 'react-toastify';

import animBtnLoading from '../../../assets/anim/anim-btnLoading.json';

import ServiceAttendance from '../../../services/ServiceAttendance';
import ServiceUtility from '../../../services/serviceUtility';

export default function PaneAttandance(props) {

    const [token] = useRecoilState(tokenAtom);
    const [attandance, setAttandance] = useRecoilState(attandanceAtom);
    const [userData] = useRecoilState(userAtom);

    const [submit, setSubmit] = useState(false);
    const [streamReady, setStreamReady] = useState(false);

    const localStreamRef = useRef();
    const canvasRef = useRef();

    const attendanceService = new ServiceAttendance();
    const utilityService = new ServiceUtility();

    const markAttandance = () => {
        if (!streamReady) {
            toast.error('Camera not accessible. Please allow camera permissions.!', { position: "top-right", autoClose: 2000, hideProgressBar: false, closeOnClick: true, progress: undefined, theme: "light" });
            return;
        }

        setSubmit(true);
        const canvas = canvasRef.current;
        const video = localStreamRef.current;
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const ctx = canvas.getContext('2d');
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        canvas.toBlob((blob) => {
            var formDataA = new FormData();
            formDataA.append("path", 'attendance');
            formDataA.append("doc", blob, 'intss.jpeg');
            utilityService.uploadFile(formDataA, token).then((res) => {
                let body = {
                    'aid': attandance._id,
                    'data': {
                        "profileMedia": res.data,
                        "status": 'open',
                    }
                }
                attendanceService.updateAttendance(body, token).then((resA) => {
                    setAttandance(resA.data);
                    setSubmit(false);
                    props.Open();
                });
            });
        }, 'image/jpeg');
    }

    const initLocalVideo = async () => {
        try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
            setStreamReady(true);
            setTimeout(() => {
                if (localStreamRef.current) {
                    localStreamRef.current.srcObject = stream;
                }
            }, 300);
        } catch (err) {
            console.error("Camera access denied or error:", err);
            setStreamReady(false);
        }
    }

    useEffect(() => {
        initLocalVideo();
    }, []);

    return (
        <div className='col-span-12 h-full bg-gray-50 rounded-lg flex flex-col items-center justify-center'>
            <div className='w-[640px] h-[480px] rounded-xl bg-black'>
                {
                    streamReady ? (
                        <div className='w-full h-full relative'>
                            <video ref={localStreamRef} autoPlay playsInline muted className='border-2 border-prime rounded-xl object-fill absolute inset-0 w-full h-full' />
                            <canvas ref={canvasRef} style={{ display: 'none' }}></canvas>
                        </div>
                    ) : (
                        <div className="w-full h-full border-2 border-prime bg-black rounded-xl flex items-center justify-center relative">
                            {
                                userData.profileMedia !== undefined && <div className='w-32 h-32 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow shadow-white'>
                                    <img src={Object.keys(userData.profileMedia).length === 0 ? "https://storage.ishcallsign.com/storage/ish-assets/default.jpeg" : userData.profileMedia.fileurl} alt='User Image' className='w-32 h-32 rounded-full object-cover' />
                                </div>
                            }
                            {
                                userData.profileMedia === undefined && <div className='w-32 h-32 rounded-full flex items-center justify-center overflow-hidden border-4 border-white shadow shadow-white'>
                                    <img src="https://storage.ishcallsign.com/storage/ish-assets/default.jpeg" alt="Profile" className="w-32 h-32 rounded-full object-cover" />
                                </div>
                            }
                        </div>
                    )
                }
            </div>
            <div className='w-full h-[10%] flex items-center justify-center'>
                <div className='bg-prime cursor-pointer h-10 w-[160px] mr-2 text-white text-sm font-medium flex items-center justify-center rounded-md' onClick={() => { markAttandance(); }}>
                    {submit && <Lottie animationData={animBtnLoading} className="w-8 h-8" />}
                    {!submit && "MARK ATTENDANCE"}
                </div>
            </div>
        </div>
    )
}
